import { gql } from 'apollo-angular';

export default gql`
  query GetDiagnosisInfo($key: String!, $language: String!) {
    getDiagnosisInfo(key: $key, language: $language) {
      key
      info {
        title
        chapters {
          heading
          content
        }
      }
    }
  }
`;
